import { Paper, TableContainer } from '@mui/material';
import { useSelector } from 'react-redux';
import OpuDetailsTable from './OPU/OpuDetailsTable';
import OpuPatientsTable from './OPU/OpuPatientsTable';
import OpuIsciTable from './OPU/OpuIcsiTable';
import OpuIvfTable from './OPU/OpuIvfTable';
import OpuCultureTable from './OPU/OpuCultureTable';
import OpuGradingTable from './OPU/OpuGradingTable';
import OpuTransferDetailsTable from './OPU/OpuTransferDetailsTable';
import OpuBiopsyTable from './OPU/OpuBiopsyTable';
import OpuFreezingTable from './OPU/OpuFreezingTable';
import OpuPregnancyTable from './OPU/OpuPregnancyTable';
import OpuSemenTable from './OPU/OpuSemenTable';

function OpuCyclesTable() {
  const { data } = useSelector((state) => state.dataAnalyticsReducer);
  return (
    <TableContainer component={Paper} style={{ display: 'flex' }}>
      <OpuPatientsTable />
      <OpuDetailsTable />
      <OpuIsciTable />
      <OpuIvfTable />
      <OpuCultureTable />
      <OpuGradingTable />
      <OpuTransferDetailsTable />
      <OpuBiopsyTable />
      <OpuFreezingTable />
      <OpuPregnancyTable />
      <OpuSemenTable />
    </TableContainer>
  );
}

export default OpuCyclesTable;
